import type { ActionFailure } from "./api/errors.js";

export function AuthenticationRecoveryButton({
  failure,
}: {
  failure: ActionFailure;
}) {
  if (!failure.fullPageReloadRequired) return null;

  return (
    <button
      className="secondary-button"
      type="button"
      onClick={() => {
        window.location.reload();
      }}
    >
      サインインし直す
    </button>
  );
}
